import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TYPE_LABELS = { hr: 'Glos workspace' };
const ROLE_LABELS = { super_admin: 'Owner', admin: 'Admin', member: 'Member' };

const AVATAR_COLORS = [
  '#1a5276','#1a7a4a','#7b2d8b','#c0392b','#d4861a',
  '#16a085','#2471a3','#7d3c98',
];

function letterColor(name) {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}

export default function AppCard({ app }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const typeLabel = TYPE_LABELS[app.type] || app.type?.toUpperCase();
  const roleLabel = ROLE_LABELS[app.my_role] || app.my_role;
  const isOwner   = app.my_role === 'super_admin';
  const isDeactivated = app.billing_status === 'suspended';
  const suspendReason = app.suspension_reason || 'manual';
  const initial   = (app.name || '?').charAt(0).toUpperCase();
  const avatarBg  = letterColor(app.name || '');

  useEffect(() => {
    const handler = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className={`ac-card${isDeactivated ? ' ac-card--deactivated' : ''}${menuOpen ? ' ac-card--menu-open' : ''}`}>
      <div className="ac-top">
        <span className="ac-type-tag">{typeLabel}</span>
        <span className={`ac-role-tag ac-role-tag--${app.my_role}`}>{roleLabel}</span>
      </div>

      <div className="ac-body">
        {app.org_logo_url ? (
          <img className="ac-avatar ac-avatar--logo" src={app.org_logo_url} alt={app.name} />
        ) : (
          <div className="ac-avatar" style={{ background: avatarBg }}>{initial}</div>
        )}
        <div className="ac-info">
          <div className="ac-name">{app.name}</div>
          <div className="ac-sub">
            {isOwner ? 'You own this workspace' : `Owned by ${app.owner_email || 'someone else'}`}
          </div>
          <div className="ac-date">
            {app.created_at ? `Created ${new Date(app.created_at).toLocaleDateString('en-GB').replace(/\//g, '-')}` : ''}
          </div>
        </div>
      </div>

      {isDeactivated ? (
        <div className="ac-deactivated-msg">
          {suspendReason === 'over_limit'
            ? 'This workspace is suspended — you\'ve exceeded your plan\'s user limit. Upgrade your plan to restore access.'
            : suspendReason === 'payment_due'
            ? 'This workspace is suspended due to a pending payment. Please clear your dues to restore access.'
            : suspendReason === 'plan_inactive'
            ? 'This workspace\'s plan is no longer available. Switch to an active plan to restore access.'
            : 'This workspace has been suspended. Contact support to restore access.'}
        </div>
      ) : (
        <div className="ac-actions">
          <button className="ac-open-btn" onClick={() => navigate(`/apps/${app.id}`)}>
            Open →
          </button>
          <div className="ac-menu-wrap" ref={menuRef}>
            <button className="ac-menu-btn" onClick={() => setMenuOpen((v) => !v)} title="More options">
              ⋮
            </button>
            {menuOpen && (
              <div className="ac-menu-dropdown">
                <button onClick={() => { navigate(`/apps/${app.id}`); setMenuOpen(false); }}>
                  Open workspace
                </button>
                <button onClick={() => { navigate(`/apps/${app.id}/setup/organisation`); setMenuOpen(false); }}>
                  Settings
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
